import type { IOrderDetails } from "./response";

export enum ReturnToCashReasonType {
  MISSED_PRODUCT_OR_QUANTITY = 1,
  PRODUCT_OR_QUANTITY_NOW_AVAILABLE = 2,
  CUSTOMER_REQUESTED_CHANGE = 3,
  OTHER = 4,
}

export enum ReturnToCashTripAction {
  NONE = 1,
  DETACHED_FROM_PENDING_TRIP = 2,
  CANCELLED_PENDING_TRIP = 3,
}

export enum ReturnToCashErrorKey {
  INVALID_STATUS = "return_to_cash_invalid_status",
  ACTIVE_TRIP = "return_to_cash_active_trip",
  TRIP_CHANGED_RETRY = "return_to_cash_trip_changed_retry",
  REQUIRES_DEDICATED_ENDPOINT = "return_to_cash_requires_dedicated_endpoint",
}

export const RETURN_TO_CASH_REASON_MIN_LENGTH = 3;
export const RETURN_TO_CASH_REASON_MAX_LENGTH = 1000;

export const RETURN_TO_CASH_REASON_TRANSLATION_KEYS: Record<
  ReturnToCashReasonType,
  string
> = {
  [ReturnToCashReasonType.MISSED_PRODUCT_OR_QUANTITY]:
    "return_to_cash_reason_missed_product_or_quantity",
  [ReturnToCashReasonType.PRODUCT_OR_QUANTITY_NOW_AVAILABLE]:
    "return_to_cash_reason_product_or_quantity_now_available",
  [ReturnToCashReasonType.CUSTOMER_REQUESTED_CHANGE]:
    "return_to_cash_reason_customer_requested_change",
  [ReturnToCashReasonType.OTHER]: "return_to_cash_reason_other",
};

export const RETURN_TO_CASH_TRIP_ACTION_TRANSLATION_KEYS: Record<
  ReturnToCashTripAction,
  string
> = {
  [ReturnToCashTripAction.NONE]: "return_to_cash_success",
  [ReturnToCashTripAction.DETACHED_FROM_PENDING_TRIP]:
    "return_to_cash_success_detached_from_trip",
  [ReturnToCashTripAction.CANCELLED_PENDING_TRIP]:
    "return_to_cash_success_cancelled_trip",
};

export interface IReturnToCashRequest {
  reasonType: ReturnToCashReasonType;
  reason?: string | null;
}

/** Raw top-level response body returned by POST /order/{id}/return-to-cash. */
export interface IReturnToCashResponse {
  order: IOrderDetails;
  auditId: number;
  tripId: number | null;
  tripAction: ReturnToCashTripAction;
  tripActionName: string;
  reasonType: ReturnToCashReasonType;
  reasonTypeName: string;
  reason: string | null;
}
